import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormikHelpers } from 'formik';

import FormSubmitError from 'errors/FormSubmitError';

import { LoginFormData } from './useInitialValues';

const useLoginSubmit = () => {
  const navigate = useNavigate();

  return useCallback(
    async (values: LoginFormData, helpers: FormikHelpers<LoginFormData>) => {
      try {
        navigate('/dashboard');
      } catch (e) {
        if (FormSubmitError.isInstance(e)) {
          helpers.setFieldError('password', (e as FormSubmitError).message);
        } else {
          console.error(e);
        }
      }
    },
    [navigate],
  );
};

export default useLoginSubmit;
